import { ClientJS } from "clientjs";
import Cookies from "universal-cookie";

function checkIsClientAndroidNative() {
    const cookies = new Cookies();
    return cookies.get('app_mode') === 'twa';
}

const clientJs = new ClientJS();
// @ts-ignore
export const isClientSafari = clientJs.isSafari();
// @ts-ignore
export const isClientMobile = clientJs.isMobile();
// @ts-ignore
export const isClientAndroid = clientJs.isMobileAndroid();
// @ts-ignore
export const isClientIOS = clientJs.isMobileIOS();
export const isClientAndroidNative = checkIsClientAndroidNative();
export const clientDeviceType = clientJs.getDeviceType();